import {User} from "models"

/**
 * @param {string} name
 * @returns {string} The initials of the name
 */
function initials(name) {
  return name.split(/\s+/).map((word) => word[0].toUpperCase())
}

/**
 * @param {User} user
 * @returns {string} The initials of the user
 */
function initialsForUser(user) {
  if (user.hasInitials()) return user.initials()

  return initials(user.name())
}

export {initialsForUser}
export default initials
